module.exports = __webpack_public_path__ + "img/Wigo_icons_redesign_car_side.14c68f9d.svg";